import { errorModal } from "../modals/ModalMessages";



class Calculator {

  #event = '';


  constructor (items, setItems, updateSessionOrder, tax) {
    this.items = items;
    this.setItems = setItems;
    this.update = updateSessionOrder;
    this.#event = 'UPDATE_QUANTITY';
    this.tax = tax;
  };


  // addEvent = (event) => {
  //   this.#event = event;
  // }

  add = async (number) => {
    try {
      if (this.items.length <= 0) {
        errorModal('CART EMPTY', <p>Please, add products to cart and try again</p>);
        return;
      }
      let items_ = [...this.items];
      let found = items_.findIndex(cart => cart.select === true);
      if (found >= 0) {
        // console.log(typeof(items_[found].quantity) === 'number');
        let quantity = items_[found].quantity + number;
        
        // checks quantity is string
        if (typeof(quantity) === 'string') {
          let quantity_ = quantity.split('.');

          if (quantity_.length === 2) {
            let decimalQuantity = quantity_[1];
            if (decimalQuantity.length > 3) return;
            if (decimalQuantity.length === 3) {
              let decimalQuantity_ = parseFloat(decimalQuantity * 1);
              quantity_[1] = decimalQuantity_;
              let newQuantity = quantity_.join('.');
              items_[found].tax *= (newQuantity * 1).toFixed(2);
              items_[found].quantity = (newQuantity * 1).toFixed(2);
              let subtotal = (items_[found].quantity) * (items_[found].sales_price*1);
              items_[found].subtotal = subtotal;
              this.setItems({event: 'UPDATE_QUANTITY', items: items_});
              return;
            };
          }
          
          let product = items_[found];
          items_[found].quantity = quantity;
          if (items_[found].tax_amount*1 >= 0 && items_[found].tax_id) {
            let subtotal = items_[found].quantity * items_[found].sales_price;
            switch (product.tax_computation) {
              case 'percent_of_price':
                items_[found]['tax'] = (parseFloat(product.tax_amount*1 / 100) * subtotal);
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
              case 'percent_of_price_included':
                items_[found]['tax'] = (parseFloat(subtotal / 1 - (product.tax_amount*1 / 100))).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
              case 'fixed':
                items_[found]['tax'] = (parseFloat(subtotal + product.tax_amount*1 / 100 )).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
            };
          }else {
            items_[found].tax = 0;
          }
          let subtotal = (items_[found].quantity) * (items_[found].sales_price*1);
          items_[found].subtotal = subtotal;
          this.setItems({event: 'UPDATE_QUANTITY', items: items_});
        }else{
          if (typeof(quantity) === 'number') {
            let subtotal = (items_[found].quantity) * (items_[found].sales_price*1);
              items_[found].subtotal = subtotal;
            this.setItems({event: 'UPDATE_QUANTITY', items: items_});
          }
        }
      };
    }catch (err) {
      console.log(err);
    }
  }


  delete = async () => {
    try {
      let carts_ = [...this.items];
      if (carts_.length > 0) {
        let cart = carts_.findIndex(cart => cart.select === true); // find cart item this is selected

        // Checks whether quantity is integer
        if (typeof(carts_[cart].quantity) === 'number') {
          // checks quantity as number then zero it
          if (carts_[cart].quantity > 0) {
            carts_[cart].quantity = 0;
            carts_[cart].tax = 0;
            carts_[cart].subtotal = (carts_[cart].quantity * 1) * (carts_[cart].sales_price*1);
            // this.setItems(carts_);
            // const order = await this.update({event: this.#event, cart: carts_});
            // this.setItems(order);
            this.setItems({event: 'UPDATE_QUANTITY', items: carts_});
          }else {
            if (carts_.length === 1) {
              carts_[0].select = true;
              carts_.pop();
            }else {
              carts_.splice(cart, 1);
              carts_[carts_.length - 1].select = true;
            }
            
            // const order = await this.update({event: this.#event, cart: carts_});
            // this.setItems(order);
            this.setItems({event: 'UPDATE_QUANTITY', items: carts_});
            // this.setItems(carts_);
          }
        }else { // quantity is string
    
          let quantity = carts_[cart].quantity.split('');
          // removes each quantity element
          quantity.pop(); 

          // quantity array one convert to number       
          if (quantity.length === 1) {
            carts_[cart].quantity = quantity[0];
          }else if (quantity.length === 0) {
            carts_[cart].quantity = 0;
          }else {
            // convert quantity array to string number
            let quantity_ = quantity.join('');
            carts_[cart].quantity = quantity_;
          }
          let product = carts_[cart];
          carts_[cart].subtotal = (carts_[cart].quantity * 1) * (carts_[cart].sales_price*1)
          if (carts_[cart].tax_id) {
            // recompute tax
            let subtotal = carts_[cart].quantity * carts_[cart].sales_price;
            switch (product.tax_computation) {
              case 'percent_of_price':
                carts_[cart]['tax'] = (parseFloat(product.tax_amount*1 / 100) * subtotal).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
              case 'percent_of_price_included':
                carts_[cart]['tax'] = (parseFloat(subtotal / 1 - (product.tax_amount*1 / 100))).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
              case 'fixed':
                carts_[cart]['tax'] = (parseFloat(subtotal + product.tax_amount*1 / 100 )).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
            };
          }
          // const order = await this.update({event: this.#event, cart: carts_});
            // this.setItems(order);
            this.setItems({event: 'UPDATE_QUANTITY', items: carts_});
          // this.setItems(carts_);
        }
      }
    }catch (err) {
      console.log(err);
    }
  }
};


export default Calculator;